import React, { useState, useEffect } from "react";
import useFilters from "hooks/useFilters";
import FileSaver from "file-saver";

import { useHistory } from "react-router-dom";
import { useStore } from "../../../../store/context";
import i18n from "i18n";

import { AuthService } from "services/AuthService";
import { OrderService } from "../../../../services/OrderService";
import { PublicService } from "../../../../services/PublicService";
import { formatDateToYyyyMmDd } from "helpers/Parsers";

import AdminLayout from "../../../../components/MainApp/layouts/DesktopLayout";
import MainNotification from "../../../../components/MainApp/atoms/Notification";
import FilterPanel from "../../../../components/MainApp/organisms/Filters/FilterPanel";
import OrdersTable from "../../../../components/MainApp/organisms/Orders/RequestOrders/Table";
import Pagination from "../../../../components/MainApp/atoms/Pagination";
import Loader from "../../../../components/MainApp/atoms/Loader";
import Search from "../../../../components/MainApp/atoms/Filters/Search";

import tableHeaders from "./data/tableHeaders";
import {
  filterData as FilterDataSource,
  filterTypeMap
} from "./data/filterData";

import { isMobile } from "../../../../helpers/Mobile";
import styles from "./RequestOrders.module.scss";
import excel from "assets/images/excel.svg";
import excelwhite from "assets/images/excelwhite.svg";
import SimpleSearchPanel from "components/MainApp/organisms/Filters/SimpleSearchPanel";
import { NotFoundItems } from "views/Admin/components/NotFoundItems";
import { set } from "date-fns";
import { capitalize } from "helpers/utils/utils_general";

const initialFilters = {
  page_size: 10,
  search: "",
  ordering: "-created_at",
  status: undefined,
  node: undefined,
  destination: undefined,
  date: [null, null]
};

let scrolling = false;

export const RequestOrdersView = () => {
  const [orderFilters, setOrderFilters] = useState();
  const history = useHistory();
  const [loading, setloading] = useState(false);
  const [filterData, setFilterData] = useState(FilterDataSource);

  const [orders_name, setOrders_name] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  // const myRef = useRef(0);

  const [
    filters,
    setFilters,
    selectedFiltersAll,
    selectedFiltersByType,
    handleApplyFilters,
    handleSearch,
    headerOrderingHandler,
    resetOrdering,
    handleFiltersChangeOrdering,
    applied,
    page,
    setPage,
    items,
    setItems,
    pager,
    setPager,
    header,
    setHeader,
    mobilePanelOpen,
    setMobilePanelOpen
  ] = useFilters(
    initialFilters,
    orderFilters,
    filterTypeMap,
    isMobile,
    tableHeaders
  );

  const headerOptions = [
    {
      icon: "icon-iconos_mas2",
      name: "add",
      handler: () => {
        history.push("/admin/orders/request/load");
      },
      tooltip: i18n.t("create.order")
    }
  ];

  useEffect(() => {
    // If specific role
    // filterData[1].enabled = true;
    // setFilterData(filterData);

    fillFilterData();
    OrderService.ordersCode({ type: "REQ" }).then(response => {
      setOrders_name(response);
    });
  }, []);

  useEffect(() => {
    setMobilePanelOpen(false);
    const first_load =
      JSON.stringify(initialFilters) === JSON.stringify(filters);
    filter(first_load);
    // Acomodar orden
    const keyOrdering =
      filters.ordering.charAt(0) === "-"
        ? filters.ordering.substr(1)
        : filters.ordering;
    if (keyOrdering in tableHeaders) {
      const newHeaders = { ...header };
      newHeaders[keyOrdering]["active"] = true;
      newHeaders[keyOrdering]["direction"] =
        filters.ordering === keyOrdering ? true : false;
      setHeader(newHeaders);
    }
  }, []);

  useEffect(() => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
      return;
    }
    filter(false);
    setOrderFilters({
      filters: filters,
      selectedFiltersAll: selectedFiltersAll,
      selectedFiltersByType: selectedFiltersByType
    });
  }, [filters, page]);

  /**
   * Prevents "background scrolling" when the mobile filter panel is open.
   * Applying overflow: hidden to both body and documentElement ensures
   * a full scroll lock across different mobile browsers.
   */
  useEffect(() => {
    if (isMobile) {
      if (mobilePanelOpen) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
        document.documentElement.style.overflow = "auto";
      }
    }

    // Cleanup to ensure scroll is restored when the component unmounts
    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, [mobilePanelOpen, isMobile]);

  /**
   * Manages the global scroll event listener for mobile infinite scrolling.
   * Uses capture phase (true) to ensure events are caught even if propagation is stopped.
   */
  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
    // Dependencies ensure the handler has access to the latest pagination and state values
  }, [page, pager.next, submitted]);

  /**
   * Infinite scroll handler for mobile devices.
   * * Uses object destructuring to extract layout properties from the event target.
   * Note: 'event.target' is the standard property, while 'event.srcElement' is
   * included as a fallback for legacy browser compatibility (IE), as srcElement
   * is considered deprecated in modern web standards.
   * * It calculates if the user has reached the bottom of the container
   * minus a 100px threshold to trigger the next page load.
   */
  const handleScroll = event => {
    if (!isMobile) return;

    // Standard destructuring with fallback for cross-browser compatibility
    const { offsetHeight, scrollTop, scrollHeight } =
      event.target || event.srcElement;

    // Threshold logic: Trigger when user is within 100px of the bottom
    if (offsetHeight + scrollTop + 100 < scrollHeight) return;

    // Concurrency control: Prevent duplicate requests if a fetch is already in progress
    if (!pager.next || submitted || scrolling) return;

    scrolling = true;
    setPage(prevPage => prevPage + 1);
  };

  const handlePagerChange = function(page) {
    setPage(page);
  };

  const filter = function(firstLoad = false) {
    let append = isMobile;
    if (!append) {
      setItems([]);
    }

    //BEFORE SUBMIT
    document.body.style.cursor = "wait";
    setSubmitted(true);
    // setErrors({})
    // setMessage({})

    const data = { ...filters, page: page };
    data["status"] = data["status"] ? data["status"].join(",") : undefined;
    data["node"] = data["node"] ? data["node"].join(",") : undefined;
    data["destination"] = data["destination"]
      ? data["destination"].join(",")
      : undefined;
    // --- SAFE DATE FORMATTING ---
    // Ensure dates are correctly parsed into YYYY-MM-DD before sending to backend
    if (data["date"] && Array.isArray(data["date"]) && data["date"][0]) {
      data["from_date"] = formatDateToYyyyMmDd(data["date"][0]);
      data["from_date_to"] = data["date"][1]
        ? formatDateToYyyyMmDd(data["date"][1])
        : undefined;
    } else {
      data["from_date"] = undefined;
      data["from_date_to"] = undefined;
    }
    delete data["date"];

    setloading(true);
    OrderService.requestOrders(data)
      .then(response => {
        //this.afterSubmit();
        setSubmitted(false);
        document.body.style.cursor = "default";
        scrolling = false;

        // if (firstLoad && response.count === 0) {
        //   history.push("/admin/products/load");
        //   setNoProducts(true)
        //   return;
        // }

        const newOrders = append
          ? [...items, ...response.results]
          : response.results;

        setloading(false);
        setItems(newOrders);
        setPager({
          next: response.next,
          previous: response.previous,
          count: response.count,
          countPages: Math.ceil(response.count / filters.page_size)
        });
      })
      .catch(e => {
        setSubmitted(false);
        setloading(false);
        document.body.style.cursor = "default";
        scrolling = false;
      });
  };

  /**
   * Populates filter data dynamically from the PublicService.
   */
  const fillFilterData = function() {
    // Load Nodes (Source and Destination)
    PublicService.nodes().then(rta => {
      // Map API response to UI-compatible option objects for 'Origin'
      const optionsNodes = rta.map(n => ({
        ...n,
        label: n.name,
        selected: false,
        type: "node",
        id: n.code
      }));

      // Map API response for 'Destination'
      const optionsDest = rta.map(n => ({
        ...n,
        label: n.name,
        selected: false,
        type: "dest",
        id: n.code
      }));

      // Perform an atomic state update to prevent partial UI renders
      setFilterData(prevData => {
        const newData = [...prevData];
        // Inject options into specific indices: 1 for Origin, 2 for Destination
        if (newData[1]) newData[1].options = optionsNodes;
        if (newData[2]) newData[2].options = optionsDest;
        return newData;
      });
    });

    // Mobile-specific: Inject Sort ordering options as a filter
    if (isMobile) {
      setFilterData(prevData => {
        // Prevent duplicate injection by checking for the 'ordering' identifier
        const hasOrdering = prevData.some(f => f.name === "ordering");

        if (!hasOrdering) {
          return [
            ...prevData,
            {
              name: "ordering",
              type: "twoOption",
              options: [
                {
                  selected: false,
                  label: i18n.t("less.recent"),
                  value: "created_at"
                }
              ],
              label: i18n.t("order.by"),
              firstOptionLabel: i18n.t("latest"),
              value: "-created_at",
              enabled: true
            }
          ];
        }
        return prevData;
      });
    }
  };

  const downloadReport = () => {
    const data = { ...filters };
    data["status"] = data["status"] ? data["status"].join(",") : undefined;
    data["node"] = data["node"] ? data["node"].join(",") : undefined;
    data["destination"] = data["destination"]
      ? data["destination"].join(",")
      : undefined;

    setloading(true);
    OrderService.requestDownloadReport(data)
      .then(blob => {
        setloading(false);
        FileSaver.saveAs(blob, "reporte.xls");
      })
      .catch(error => {
        setloading(false);
      });
  };

  const goToDetailPage = event => {
    history.push(
      `/admin/orders/request/details/${event.currentTarget.dataset.requestorderId}`
    );
  };

  const goToEditPage = event => {
    history.push(
      `/admin/orders/request/edit/${event.currentTarget.dataset.requestorderId}`
    );
  };

  const headerButtons = (
    <div
      className="excel-button"
      onClick={downloadReport}
      style={{
        width: "30px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center"
      }}
    >
      <img style={{ height: "30px" }} src={isMobile ? excelwhite : excel} />{" "}
    </div>
  );

  const mobileContent = (
    <div className={styles["orders-request-content-wrapper"]}>
      <SimpleSearchPanel
        placeholder={i18n.t("search")}
        handleSubmit={handleSearch}
      />

      {mobilePanelOpen && (
        <div
          className={`${styles["orders-request-table-mobile-panel"]} ${
            mobilePanelOpen ? styles["opened"] : ""
          }`}
        >
          <FilterPanel
            resultList={orders_name}
            placeholder={i18n.t("search.by.name.or.code")}
            searchValue={filters.search}
            handleSubmitSearch={handleSearch}
            filters={filterData}
            selectedFiltersAll={selectedFiltersAll}
            selectedFiltersByType={selectedFiltersByType}
            handleApplyFilters={handleApplyFilters}
            closeMobilePanel={() => {
              setMobilePanelOpen(false);
            }}
          />
        </div>
      )}
      <div className={styles["orders-request-table-table"]}>
        <div className={styles["orders-request-table-top-table"]}>
          <div className={styles["orders-request-table-top-total"]}>
            {capitalize(i18n.t("total"))}{" "}
            <span className={styles["orders-request-table-top-total-bold"]}>
              ({pager.count})
            </span>
          </div>
          <div
            className={`${styles["orders-request-table-top-sort"]} ${
              applied ? styles["orders-request-table-active-filter"] : ""
            }`}
            onClick={() => {
              setMobilePanelOpen(true);
            }}
          >
            <i
              className={`icon-iconos_filtros ${styles["orders-request-table-top-icon"]}`}
            ></i>
          </div>
        </div>
        <OrdersTable
          requestOrders={items}
          headers={header}
          handleClickRequestOrder={goToDetailPage}
          handleClickDraft={goToEditPage}
        />
      </div>

      {items.length === 0 && !submitted && <NotFoundItems />}
    </div>
  );

  // DESKTOP START
  const desktopContent = (
    <div className={styles["orders-request-content-wrapper"]}>
      <FilterPanel
        resultList={orders_name}
        placeholder={i18n.t("search.by.name.or.code")}
        searchValue={filters.search}
        handleSubmitSearch={handleSearch}
        filters={filterData}
        selectedFiltersAll={selectedFiltersAll}
        selectedFiltersByType={selectedFiltersByType}
        handleApplyFilters={handleApplyFilters}
      ></FilterPanel>

      {items.length > 0 && (
        <div className={styles["orders-request-table-table"]}>
          <div className={styles["orders-request-table-top-table"]}>
            <div className={styles["orders-request-table-top-total"]}>
              {capitalize(i18n.t("total"))}{" "}
              <span className={styles["orders-request-table-top-total-bold"]}>
                ({pager.count})
              </span>
            </div>
            <div className={styles["orders-request-table-top-sort"]}>
              <div
                data-automation-id="orders-request-table-sort"
                className={
                  filters.ordering.includes("created_at")
                    ? `${styles["orders-request-table-top-sort"]} ${styles["orders-request-table-active-filter"]}`
                    : styles["orders-request-table-top-sort"]
                }
                onClick={() => {
                  handleFiltersChangeOrdering(
                    "ordering",
                    filters.ordering === "-created_at"
                      ? "created_at"
                      : "-created_at"
                  );
                  resetOrdering();
                }}
              >
                {filters.ordering === "created_at" ? (
                  <React.Fragment>
                    {i18n.t("less.recent")}{" "}
                    <i
                      className={`icon-chevron ${styles["orders-request-table-top-icon"]}`}
                    ></i>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {" "}
                    {i18n.t("latest")}{" "}
                    <i
                      className={`icon-chevron-down ${styles["orders-request-table-chevron-down"]} ${styles["orders-request-table-top-icon"]}`}
                    ></i>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
          <OrdersTable
            requestOrders={items}
            headers={tableHeaders}
            headerClickHandler={headerOrderingHandler}
            handleClickRequestOrder={goToDetailPage}
            handleClickDraft={goToEditPage}
          />
        </div>
      )}

      {items.length === 0 && !submitted && <NotFoundItems />}
      {items.length > 0 && (
        <div>
          <Pagination
            pageQuantity={pager.countPages}
            currentPage={page}
            pageChangeHandler={handlePagerChange}
          />
        </div>
      )}
    </div>
  );
  // DESKTOP END

  const content = (
    <div className={styles["orders-request-content-container"]}>
      {isMobile ? mobileContent : desktopContent}
    </div>
  );

  return (
    <div className={styles["orders-request-container"]}>
      <AdminLayout
        headerTitle={i18n.t("replacement.ordes")}
        headerOptions={headerOptions}
        content={content}
        navHidden={false}
        customButtons={headerButtons}
        goBackFunc={() => {
          history.push("/admin/orders");
        }}
      ></AdminLayout>
      {loading && <Loader />}
      <MainNotification
        label={i18n.t("product.updated.successfully.message")}
        open={false}
      ></MainNotification>
    </div>
  );
};

export default RequestOrdersView;
